import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CreditCard, Save } from "lucide-react";
import { toast } from "sonner";

export default function CardFeeSettings() {
  const [percent, setPercent] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setPercent(String(data.card_fee_percent ?? 0))).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const val = parseFloat(String(percent).replace(",", ".")) || 0;
      await api.put("/admin/settings", { card_fee_percent: val });
      setPercent(String(val));
      toast.success("Taxa do cartão salva!");
    } catch {
      toast.error("Erro ao salvar a taxa.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl mb-6">
      <div className="bg-[#1C1917] border border-[#292524] rounded-xl p-4">
        <p className="text-sm font-semibold mb-1 flex items-center gap-2">
          <CreditCard className="w-4 h-4" /> Taxa da maquininha (cartão)
        </p>
        <p className="text-xs text-stone-500 mb-3">
          Quando o cliente escolher pagamento com cartão, este percentual é somado ao total automaticamente.
        </p>
        <div className="flex items-end gap-3">
          <div className="w-40">
            <Label className="text-stone-300">Percentual (%)</Label>
            <Input
              data-testid="card-fee-input"
              value={percent}
              onChange={(e) => setPercent(e.target.value)}
              placeholder="Ex.: 3.5"
              className="bg-[#0C0A09] border-[#292524] text-stone-100"
            />
          </div>
          <button
            onClick={save}
            disabled={saving}
            data-testid="save-card-fee-btn"
            className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60"
          >
            <Save className="w-4 h-4" /> {saving ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}
